import { Box, Typography, Video } from "@jewlr/storybook/core"
import React from "react"

import { IS_UK } from "helpers/application"

const AboutOurWatches = () => (
  <Box mb={5} textAlign="center">
    <Typography
      fontSize={25}
      mx="auto"
      my={{ _: 3, tablet: 4 }}
      width={{ _: "55%", tablet: "100%" }}
    >
      Learn More{" "}
      <Typography as="span" display={{ _: "none", tablet: "inline-block" }}>
        About Our Watches
      </Typography>
    </Typography>

    <Video
      autoPlay={false}
      options={{
        controls: true,
        muted: false,
        playsInline: true,
      }}
      poster={`${sl.config.jewlr_asset_url}homepage_videos/2021/2021_jewlr_watches_promo_video_thumb_v2.png`}
      style={{ margin: "auto", width: { _: "94%", tablet: "98%" } }}
      video={`${sl.config.jewlr_asset_url}homepage_videos/2021/${
        IS_UK()
          ? "jewlr_watches_promo_video_uk"
          : "2021_jewlr_watches_promo_video_final"
      }.mp4`}
    />
  </Box>
)

export default AboutOurWatches
